module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter41"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block57"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h158"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Travis")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p2720"
    }
  }, [_vm._v("The one I’m eyeing for the night bends at her waist and lines her pool stick up with the cue ball. She slowly pulls the wooden rod through her fingers until the felt top finally connects. The hard, white plastic ball rolls toward her target, hitting it perfectly and stalling as the blue-striped ball rolls into the pocket. I let out a massive sigh and lean on my stick, waiting my turn. I should’ve known better when she approached me, asking if I wanted to play a game or two of billiards with her. I know better than to let a good-looking woman hustle me out of money, but I wasn’t thinking with my right head. I never am, and once again I’m getting my balls busted, no pun intended, by a pool shark.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2721"
    }
  }, [_vm._v("“Sweetheart, are you going to let me play? My balls are getting lonely.” If she thinks I’m crude, she doesn’t say anything. In fact, she looks at me from over her shoulder and winks before shimmying her ass toward my crotch. My internal groan is epic. For almost an hour, she’s been leaning over, licking her lips, showing her ample cleavage, and shaking her ass. Not to mention, she brushes against me each time she passes me. And the touching isn’t subtle. I can read her loud and clear, all the way from her tight-as-sin jeans to her plunging neckline.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2722"
    }
  }, [_vm._v("“I can’t help it if you suck.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2723"
    }
  }, [_vm._v("“Do you?” I ask, stepping in behind her. My crotch is lined up perfectly with her backside, earning me another hair-tossing look over her shoulder.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2724"
    }
  }, [_vm._v("She stands and turns to face me, sitting her ass on the edge of the table. “What do you have in mind?” Her finger trails down the front of my shirt until she reaches the buckle of my belt. The tug is slight, but definitely felt. Message received loud and clear.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2725"
    }
  }, [_vm._v("“What’s your name?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2726"
    }
  }, [_vm._v("“Are names important?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2727"
    }
  }, [_vm._v("“Of course. When I demand that you come for me, I need to know what to call you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2728"
    }
  }, [_vm._v("“Demand?” she questions.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2729"
    }
  }, [_vm._v("“I’m greedy like that,” I tell her, placing my cue stick against the table as I step closer to her. I lean in and try to get a whiff of her perfume, but a mix between the stale air from the bar and the beer on her breath makes it hard to tell what she’s wearing. I do love a woman who takes the time to add the perfect scent on her skin, though.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2730"
    }
  }, [_vm._v("“Blue.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2731"
    }
  }, [_vm._v("“My balls aren’t blue, darling, and haven’t been in years.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2732"
    }
  }, [_vm._v("“No, my name is Blue.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2733"
    }
  }, [_vm._v("“That’s a very unique name,” I say as my hand rests on her hip.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2734"
    }
  }, [_vm._v("“What can I say? I’m a unique woman, Travis.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2735"
    }
  }, [_vm._v("Ah, she knows my name. That’s usually how things go for me. Rarely am I given the opportunity to introduce myself. Everyone knows who I am, and while I enjoy the fruits of my labor, sometimes anonymity would be nice. One day, I’d like to talk to a woman who doesn’t know that I’m Travis Kidd, left fielder for the Boston Renegades and one of the town’s most eligible bachelors. “You know who I am?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2736"
    }
  }, [_vm._v("“Doesn’t everyone? I’m a Boston girl; I know my Renegades.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2737"
    }
  }, [_vm._v("I nod and reach for my beer. It’s the off-season, and technically I shouldn’t be here. I usually head south for the winter but opted to stay home this time. After a long season, one that saw my former manager die and one of my closest friends on the team become a dad to twins, I thought I’d stay around and see what the winter had to offer. Aside from the cold, I haven’t found much, except Bruins hockey and Celtics basketball. Those games have been the highlight of my time off.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2738"
    }
  }, [_vm._v("The pickings for women have been slim. Without trying to bag on the female population, it’s evident that they’re seasonal as well. Right now, the puck bunnies, gridiron groupies, and court whores are in full effect, and the cleat-chasers are resting like the rest of the baseball world. Maybe I should’ve been a dual-sport athlete. That way I would’ve had the best of both worlds.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2739"
    }
  }, [_vm._v("“Travis?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2740"
    }
  }, [_vm._v("“What?” I ask, mentally shaking the cobwebs out.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2741"
    }
  }, [_vm._v("“Where’d you go? It’s your turn.” Blue nods toward the table, and I look over her shoulder to see the cue ball sitting there.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2742"
    }
  }, [_vm._v("“Why don’t you help me?” I know how to play the game of pool, but since she seems to be a pro, why shouldn’t she show me? I would’ve happily slid up behind her and taught her how to handle her stick, but she took the fun out of it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2743"
    }
  }, [_vm._v("Instead, she’s off to my side and leaning into me, giving me a perfect sideways glance down her shirt. I smirk, ignoring everything she tells me, and watch as her mounds of flesh move each time her hand does. They’re real, that’s for sure. None of that fake silicone shit on this chick.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2744"
    }
  }, [_vm._v("“And that’s how it’s done,” she says, righting herself. She continues to slightly lean over the table, though, jutting her chest out for me to ogle. I cock my head to the side and wink before taking aim at the cue on the table.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2745"
    }
  }, [_vm._v("My first shot goes in, and the second quickly follows. I line up the third and fire, and that is when I see a raven-haired beauty nursing a drink at the bar.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2746"
    }
  }, [_vm._v("Saylor Blackwell is off-limits to anyone her agency represents. That includes me. Although I wish it didn’t. I would have switched managers to be with her if she asked me to, but I fucked that up. When she needed me, I wasn’t there. And I haven’t spoken to her since.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2747"
    }
  }, [_vm._v("It’s my dumb luck that she’s sitting at the bar with her long, slender legs crossed. She’s dressed like she recently got off work, and her eyes are set on the television, ignoring the gaggle of men staring at her. I remember that she was a hard nut to crack back when I wanted to know her better. I can’t imagine what she’s like now that she’s even more successful.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2748"
    }
  }, [_vm._v("My last shot is sunk into the corner pocket. “Eight ball, right side,” I say, nodding in the same direction I plan to send the black ball in order to finish this game. I’m in a rush now, eager to speak with Saylor. I know I shouldn’t but I can’t help myself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2749"
    }
  }, [_vm._v("“Where ya going?” Blue calls out.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2750"
    }
  }, [_vm._v("“To the bar. Rack ’em,” I tell her. It’s not a lie. I am going to the bar, but with the intention of speaking to another woman. I’m smooth, though, and I can easily play it off while I order another round of drinks.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2751"
    }
  }, [_vm._v("“Two, please.” I put up two fingers as I motion toward the bartender. Leaning in, I know I’m blocking Saylor’s view of the television, which is all in my game plan. “Hey, Saylor.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2752"
    }
  }, [_vm._v("“Travis,” she says coldly. I often remember the night we spent together and the regret that was on her face when we were done. Even though we were at my house, I wanted to leave. I had never felt so uncomfortable after getting laid. Everything was awkward, from the way she spoke to how fast she dressed and ran out of my place. Rarely do I bring women home, opting for theirs so I can bail, but Saylor was different. I still can’t get that night out of my mind, and it’s been almost two years. With Saylor, everything was backward. It’s like she used me to scratch an itch, and once I took care of that, she didn’t need me anymore. “What brings you in?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2753"
    }
  }, [_vm._v("She looks everywhere but at me. “I’m meeting a client.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2754"
    }
  }, [_vm._v("“And nursing your what?” I take her drink from her hand and sniff. “Scotch? When did you start drinking the hard shit?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2755"
    }
  }, [_c('i', [_vm._v("That")]), _vm._v(" gets her to look at me. Her glare is deadly as it penetrates mine. “As if you know anything about me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2756"
    }
  }, [_vm._v("“I know enough.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2757"
    }
  }, [_vm._v("“You don’t know shit, Travis Kidd. Go back to your booty call. She’s looking at me like she’s ready for a catfight, and I assure you, you’re not worth fighting for.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2758"
    }
  }, [_vm._v("Saylor turns, giving me the cold shoulder. If I weren’t so stunned by her outburst, which I did not deserve, I’d tease her. But there’s obviously something bothering her, and I’m the last person she needs making shit worse.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2759"
    }
  }, [_vm._v("With the bottles of beer dangling between my fingers, I go back to the pool table where Blue is indeed throwing daggers at Saylor’s back.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2760"
    }
  }, [_vm._v("“Down, kitty. She works for my manager.” I run my hand down her arm, trying to defuse the situation. Jealous women usually turn me off, and this should be my sign to hit the road, except I’m an idiot and want to stay mostly so I can watch Saylor.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2761"
    }
  }, [_vm._v("Taking Blue by her hand, I lead us over to the stools, and I sit down, pulling her between my legs. My hand is planted firmly on her leg right under her butt cheek. It’s a risky move, given all the nosey Renegades fans who are always around, but I don’t care right now. It’s the off-season. I’m allowed to have a little bit of fun.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2762"
    }
  }, [_vm._v("“You have nothing to be jealous over,” I tell her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2763"
    }
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2764"
    }
  }, [_vm._v("“We good? Wanna go back to kicking my ass at pool?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2765"
    }
  }, [_vm._v("She looks over at the table and nods. “You rack, and I’ll break.” Blue saunters away, giving me space to watch Saylor, who turns and makes eye contact with me. I wish I could tell what she’s thinking. Is she second-guessing her harsh words? I am. I want to go back over and offer to pick up her tab. Or ask how she’s getting home. It’s late, and the roads are shit. If she’s driving, she shouldn’t be drinking. She has a kid that depends on her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2766"
    }
  }, [_vm._v("“I’m ready,” Blue says seductively. The tone of her words catches me off guard. It’s hard to decipher if she’s ready to play another game or two of pool. I hope that’s what she means because I have no intention of leaving as long as Saylor is at the bar. Or is Blue ready for me to fuck her and never ask for her number? Because that is bound to happen as well.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2767"
    }
  }, [_vm._v("I break, sending the balls off in every direction. Four drop. Two of each, giving me the choice of what I want to be. Blue is yammering in my ear about the setup and which would be the best. Her angles only work for her, though, and I see that I can run the table on her if I line up correctly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2768"
    }
  }, [_vm._v("“We should’ve bet,” I tell her as I walk around the table.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2769"
    }
  }, [_vm._v("“I’d hate to hustle you out of your money, Travis.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2770"
    }
  }, [_vm._v("I laugh off her comment and proceed to clear the table. She huffs when the eight ball falls into the designated pocket.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2771"
    }
  }, [_vm._v("“Well, would you look at that,” I say, taking a bow. Blue pushes me lightly and falls into my arms. Her lips are on mine before I can push her away, and doing so now would be embarrassing for her, so I kiss her back and find myself opening my eyes to watch Saylor watch me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2772"
    }
  }, [_vm._v("As soon as I pull away, Saylor is sliding off the bar stool and heading toward the door.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2773"
    }
  }, [_vm._v("“Be right back. I need some fresh air.” A true gentleman would’ve invited his lady friend outside, but that is not who I am.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2774"
    }
  }, [_vm._v("“Do you need a ride home?” I ask as soon as I see Saylor standing near the curb. “And what happened to your client?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2775"
    }
  }, [_vm._v("“He canceled.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2776"
    }
  }, [_vm._v("It didn’t strike me as odd earlier when she said she was meeting a client, but it does now. I’ve never met anyone from the agency at a bar, let alone this late at night.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2777"
    }
  }, [_vm._v("“How about that ride home?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2778"
    }
  }, [_vm._v("“Travis.” She draws out my name and then drops her head into her hands. Without thinking, I pull her into my side. “Come on, Saylor. It’s a ride. Nothing else.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2779"
    }
  }, [_vm._v("“What the hell is going on? I thought you were taking me home.” Blue speaks loud enough for everyone on the block to hear.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2780"
    }
  }, [_vm._v("My arm drops, and Saylor steps away from me. I turn at the sound of Blue’s voice behind me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2781"
    }
  }, [_vm._v("“I’ll be in. Give me a minute.” I smile, hoping to placate Blue, but it doesn’t work.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2782"
    }
  }, [_vm._v("“I see some things never change,” Saylor says as she steps off the curb and waves at a cab, only to be passed by.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2783"
    }
  }, [_vm._v("Shaking my head, I push my hands into my pockets for a bit of warmth. If I knew Saylor would be out here when I returned, I’d run in and grab my jacket. “It’s not like that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2784"
    }
  }, [_vm._v("“What, do you like her or something?” The sound of Blue’s voice grates on my nerves.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2785"
    }
  }, [_vm._v("Saylor looks over my shoulder and rolls her eyes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2786"
    }
  }, [_vm._v("“Or something,” I say, without taking my eyes off Saylor.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2787"
    }
  }, [_vm._v("As soon as a taxi pulls up to the curb, Saylor is sliding in.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2788"
    }
  }, [_vm._v("I make a split-second decision to get in with her, but not before Blue yells at me. “Where the fuck are you going?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2789"
    }
  }, [_vm._v("I answer her by slamming the door shut. I have Blue on the outside screaming and Saylor looking at me like she’s going to kill me. Saylor opens the door, and I hear Blue say, “Fuck you, Travis Kidd. You’ll pay for this.” And before I realize what’s happening, Saylor is standing outside the cab. When we drive off, my tongue is tied, and I watch through the back window as Saylor disappears the farther I get down the road.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-506a9e08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s005-Chapter-001.vue
// module id = 72
// module chunks = 0